import fetcher from 'api/fetcher';
import { AxiosRequestConfig } from 'axios';

type UploadOrdReportProps = {
    file: File;
    onProgress?: (percentage: number, totalMB: number) => void;
};

const UPLOAD_URL = '/api/v1/backoffice/yandex_ord_report';

export const uploadOrdReport = async ({ file, onProgress }: UploadOrdReportProps): Promise<void> => {
    const formData = new FormData();
    formData.append('file', file);

    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: onProgress
            ? (progressEvent: ProgressEvent) => {
                  if (progressEvent.total) {
                      const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                      const totalMB = progressEvent.total / (1024 * 1024);
                      onProgress(percentage, totalMB);
                  }
              }
            : undefined,
    };

    try {
        await fetcher.post(UPLOAD_URL, formData, requestConfig);
    } catch (error) {
        throw error;
    }
};
